// Ideally this would be done for us in the database, but for now we hard-code the required order here
const skillOrder = ['THROTTLE', 'BRAKING', 'STEERING'];

export function skillNameComparer(a: string, b: string) {
  return skillOrder.indexOf(a.trim().toUpperCase()) - skillOrder.indexOf(b.trim().toUpperCase())
}